import { render, staticRenderFns } from "./OcorrenciasForm.vue?vue&type=template&id=d76c9fac&"
import script from "./OcorrenciasForm.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports